import { UrlParams } from "../components/datatable/interfaces";

export default function serializeToQueryParams(urlParams: UrlParams) {
  return Object.keys(urlParams)
    .reduce<string[]>((keyValuePairs, paramKey) => {
      const paramValue = urlParams[paramKey];
      if (paramValue !== undefined) keyValuePairs.push(`${paramKey}=${paramValue}`);
      return keyValuePairs;
    }, [])
    .join("&");
}
